import React, { useMemo, useRef } from 'react';
import {
  TablePaginatedV8,
  TableCellV8,
  CellDateTimeV8,
  CellFloatCustomV8,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaMinus } from 'react-icons/fa';

import { useRootStore } from 'store';
import { FormatDateTime } from 'shared-pages/common/date-helpfunc';

export const TransIdocsTable = ({
  data,
  headerAction = null,
  onUnlinkIdoc = undefined,
  canEdit = false,
}) => {
  const { t } = useTranslation();
  const { appStore, tableStore } = useRootStore();
  const gridRef = useRef(null);

  const columns = useMemo(
    () => [
      {
        id: 'identificationDocument',
        header: t('Κωδικός Εντύπου'),
        columnName: t('Κωδικός Εντύπου'),
        accessorKey: 'identificationDocument',
        orderByField: 'identificationDocument',
        cell: ({ row }) => (
          <Link to={`/idoc/${row.original.id}`} className="text-start">
            {row.original.identificationDocument}
          </Link>
        ),
        size: 20,
      },
      {
        id: 'dateCollected',
        header: t('Ημερομηνία Συλλογής'),
        columnName: t('Ημερομηνία Συλλογής'),
        accessorKey: 'dateCollected',
        orderByField: 'dateCollected',
        cell: CellDateTimeV8,
        size: 50,
        meta: { type: 'text' },
      },
      {
        id: 'collectionPointName',
        header: t('Προέλευση Αποβλήτων'),
        columnName: t('Προέλευση Αποβλήτων'),
        accessorKey: 'collectionPointName',
        orderByField: 'collectionPointName',

        cell: ({ getValue, row }) => (
          <div className="text-start">
            <div>{row.original.collectionPointName}</div>
            <div style={{ color: 'gray', fontSize: 'smaller' }}>
              {' '}
              {row.original.colpointAddressLine1}
            </div>
          </div>
        ),
        size: 25,
        meta: { type: 'text' },
      },
      {
        id: 'collectorCompanyName',
        header: t('Συλλέκτης'),
        columnName: t('Συλλέκτης'),
        accessorKey: 'collectorCompanyName',
        orderByField: 'collectorCompanyName',
        cell: TableCellV8,
        size: 30,
        meta: { type: 'text' },
      },
      {
        id: 'vehPlateNumber',
        header: t('Όχημα'),
        columnName: t('Όχημα'),
        accessorKey: 'vehPlateNumber',
        orderByField: 'vehPlateNumber',
        cell: ({ getValue, row }) => (
          <div className="text-start">
            {row.original.vehPlateNumber}
            <div style={{ color: 'gray', fontSize: 'smaller' }}> {row.original.driverFullName}</div>
          </div>
        ),
        size: 20,
      },
      {
        id: 'wastereceptionpointCompanyName',
        header: t('Παραλαβή Αποβλήτων'),
        columnName: t('Παραλαβή Αποβλήτων'),
        accessorKey: 'wastereceptionpointCompanyName',
        orderByField: 'wastereceptionpointCompanyName',
        cell: TableCellV8,
        size: 30,
        meta: { type: 'text' },
      },
      {
        id: 'receptionNetWeight',
        header: t('Βάρος Αποβλήτων'),
        columnName: t('Βάρος Αποβλήτων'),
        accessorKey: 'receptionNetWeight',
        orderByField: 'receptionNetWeight',
        cell: CellFloatCustomV8(8, 1),
        size: 30,
        meta: { type: 'text' },
      },

      {
        id: 'dateStorage',
        header: t('Ημερομηνία Παράδοσης'),
        columnName: t('Ημερομηνία Παράδοσης'),
        accessorKey: 'dateStorage',
        orderByField: 'dateStorage',
        cell: CellDateTimeV8,
        size: 50,
        meta: { type: 'text' },
      },
      {
        id: 'finaldestinationCompanyName',
        header: t('Τελική Διάθεση Αποβλήτων'),
        columnName: t('Τελική Διάθεση Αποβλήτων'),
        accessorKey: 'finaldestinationCompanyName',
        orderByField: 'finaldestinationCompanyName',
        cell: ({ getValue, row }) => (
          <div className="text-start">
            {row.original.finaldestinationCompanyName}
            <div style={{ color: 'gray', fontSize: 'smaller' }}>
              {row.original.finaldestinationCompanyNoteDocNumber}
              {row.original.finaldestinationCompanyNoteDocNumber ? ' - ' : ''}
              {FormatDateTime(row.original.finalDestinationDate)}
            </div>
          </div>
        ),
        size: 50,
        meta: { type: 'text' },
      },
      {
        id: 'actions',
        header: t('Ενέργειες'),
        columnName: t('Ενέργειες'),
        accessorKey: 'actions',
        size: 80,
        cell: ({ row }) => (
          <div className="text-center">
            {canEdit && onUnlinkIdoc ? (
              <Button
                className="btn-circle-lg btn-danger text-white"
                title={t('Αφαίρεση σύνδεσης')}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, color: '#fff' }}
                onClick={(e) => {
                  e.stopPropagation();
                  onUnlinkIdoc(row.original);
                }}
              >
                <FaMinus style={{ color: '#fff' }} />
              </Button>
            ) : (
              '-'
            )}
          </div>
        ),
      },
      // isActiveColumn(t, i18n),
      // firstDateUserColumn(t),
      // lastDateUserColumn(t),
      /* ...(!isGridInForm && appStore.isPlatformOwner
            ? [
                {
                  id: 'edit',
                  header: t('Ενέργειες'),
                  columnName: t('Ενέργειες'),
                  accessorKey: 'edit',
                  orderByField: 'lastUser',
                  size: 120,
                  cell: ({ row, table }) => {
                    return true ? EditCellV8({ row, table }) : <>-</>;
                  },
                },
              ]
            : []), */
    ],
    [t, canEdit, onUnlinkIdoc],
  );

  return (
    <div>
      <div
        className="form-group-title d-flex justify-content-between align-items-center overflow-y-hidden"
        style={{ marginBottom: '0px' }}
      >
        <div>
          <h5 className="align-self-center" style={{ marginBottom: '0px' }}>
            {t('Προέλευση Αποβλήτων - Ιχνηλασιμότητα ΕΑΕΑ')}
          </h5>
          <small className="text-white-50">
            {t('Επιλέξτε τα έντυπα, των αποβλήτων που μεταφέρονται με την διακίνηση.')}
          </small>
        </div>
        {headerAction}
      </div>
      <TablePaginatedV8
        style={{ overflow: 'visible' }}
        ref={gridRef}
        loading={false}
        id="collection-lines-grid"
        appStore={appStore}
        tableStore={tableStore}
        key="collection-lines-grid"
        columns={columns as any}
        data={data ?? []}
        dataCount={data?.length ?? 0}
        topBorderRadius={false}
        initSorting={[{ id: 'id', desc: true }]}
      />
    </div>
  );
};
